import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
// Custom components
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  productReports,
  productExcel,
  salesReports,
} from '../../../redux/actions/Report.action';
import { IoSearchOutline } from 'react-icons/io5';
import { Button, Modal } from 'react-bootstrap';
import { viewSaleBill } from '../../../redux/actions/Billing.action';
import { VscTarget } from 'react-icons/vsc';
import * as XLSX from 'xlsx';
import ReactPaginate from 'react-paginate';

export default function ProductReport() {
  const dispatch = useDispatch();
  const reportData = useSelector((state) => state.report);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;
  const limits = {
    page: currentPage,
    limit: itemsPerPage
  }
  const [formData, setFormData] = useState({
    search: '',
  });

  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  useEffect(() => {
    let payload = {}
    if (formData) {
          payload.page = currentPage;
          payload.limit = itemsPerPage;
          payload.search = formData.search;
          dispatch(productReports(payload, limits));
          dispatch(productExcel(payload))
        }
  }, [formData,currentPage,itemsPerPage]);

  const filteredData = reportData?.productReport?.data?.data || [];
  const totalCount = reportData?.productReport?.data?.totalCount || 0;
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [formData.search]);

  // Handle Page Change
  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected + 1);
  };

  const handleDownload = () => {
    if (!reportData?.productExcel?.data?.data || reportData?.productExcel?.data?.data.length === 0) {
      alert('No data available to download!');
      return;
    }

    const exportData = reportData?.productExcel?.data?.data.map((item) => ({
      'Product Name': item.productName,
      Pack: item.salePack,
      Qty: item.totalQty,
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Product Report');

    XLSX.writeFile(workbook, `Product_Report.xlsx`);
  };

  return (
    <>
      <div className="mt-[100px]">
        <div className="d-flex items-center gap-3">
          <div className="bg-white shadow-shadows py-[8px] px-[20px] rounded-full flex items-center gap-2 me-2 ms-auto">
            <IoSearchOutline />
            <input
              type="text"
              name="search"
              value={formData.search}
              onChange={handleFormData}
              className="w-full outline-none"
              placeholder="Search..."
            />
          </div>
          <div>
            <Button
              onClick={handleDownload}
              className="px-4 !bg-theme-dark border-0 text-white"
            >
              Download
            </Button>
          </div>
        </div>
        <div className="text-end mt-4">
          Total Records:{' '}
          <span className="text-success border-b border-success">
            {filteredData?.length || 0}
          </span>
        </div>
      </div>
      <div className="mt-[50px] mb-4">
        <TableContainer>
          <Table variant="striped" colorScheme="blackAlpha">
            <Thead>
              <Tr>
                <Th>Product Name</Th>
                <Th>Pack</Th>
                <Th>Qty</Th>
              </Tr>
            </Thead>
            <Tbody>
              {filteredData?.length > 0 ? (
                filteredData?.map((res, index) => {
                  return (
                    <Tr key={index}>
                      <Td className="uppercase">{res.productName}</Td>
                      <Td className="uppercase">{res.salePack}</Td>
                      <Td>{res.totalQty}</Td>
                    </Tr>
                  );
                })
              ) : (
                <Tr>
                  <Td colSpan={3} textAlign={'center'}>
                    No any report
                  </Td>
                </Tr>
              )}
            </Tbody>
          </Table>
        </TableContainer>
      </div>
      {filteredData?.length > 0 && <>
      
      <ReactPaginate
      breakLabel="..."
      nextLabel="next >"
      onPageChange={handlePageChange}
      pageRangeDisplayed={10}
      pageCount={totalPages}
      previousLabel="< previous"
      renderOnZeroPageCount={null}
      className="pagination"
      forcePage={currentPage - 1}
    />
    </>}
    </>
  );
}
